import styled from '@emotion/styled'

interface Props {
  disabled?: boolean
}

const FormHint = styled.span<Props>(
  (props) => ({
    display: 'block',
    color: props.theme.colors.texts.textMuted,
    fontFamily: props.theme.fonts.families.body,
    fontSize: props.theme.fonts.sizes.label.small,
    letterSpacing: props.theme.fonts.spacing.body,
    marginTop: '0.4em',
    marginBottom: '0.2em',
  }),
  (props) =>
    props.disabled && {
      opacity: props.theme.opacities.disabledInput,
    }
)

export default FormHint
